import Trix from "trix";
import ModuleSelectorModal from "./module-selector-modal";
import ModuleEditor from "./module-editor";

class ModuleInserterController {
  constructor(element) {
    this.element = element;
    this.editor = element.editor;
    this.toolbar = element.toolbarElement;

    this.buttonElement = this.toolbar.querySelector(
      "[data-trix-action='insert-module']"
    );

    this.modal = new ModuleSelectorModal();
    this.moduleSchemas = null; // Will be loaded from API
    this.moduleEditor = null; // Will be initialized after schemas load

    if (this.buttonElement) {
      this.installEventHandlers();
      this.loadModuleSchemas();
    }
  }

  loadModuleSchemas() {
    return fetch("/cms/marketing_page_modules/schemas", {
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": document.head.querySelector('meta[name="csrf-token"]')
          .content,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Failed to load module schemas");
      })
      .then((data) => {
        this.moduleSchemas = data.schemas;
        // Initialize module editor for editing existing modules
        if (!this.moduleEditor && this.moduleSchemas) {
          this.moduleEditor = new ModuleEditor(this.editor, this.moduleSchemas);
        }
        return data;
      })
      .catch((error) => {
        console.error("Error loading module schemas:", error);
        // Fallback to empty object - user will see modules but no config forms
        this.moduleSchemas = {};
        return { schemas: {} };
      });
  }

  installEventHandlers() {
    this.buttonElement.addEventListener("click", this.insertModule.bind(this));
  }

  insertModule(event) {
    event.preventDefault();

    // Load schemas if not already loaded
    if (!this.moduleSchemas) {
      this.loadModuleSchemas().then(() => {
        this.showModuleSelector();
      });
    } else {
      this.showModuleSelector();
    }
  }

  showModuleSelector() {
    // Fetch available modules from API
    fetch("/cms/marketing_page_modules/schemas", {
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": document.head.querySelector('meta[name="csrf-token"]')
          .content,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Failed to load modules");
      })
      .then((data) => {
        const availableModules = data.modules || [];
        this.moduleSchemas = data.schemas || {};

        this.modal.show(availableModules, (moduleType) => {
          // Show configuration form for selected module
          const schema = this.moduleSchemas[moduleType];
          if (schema) {
            this.modal.showConfig(
              moduleType,
              schema,
              (type, config) => {
                this.createModule(type, config);
              },
              () => {
                // User cancelled config - do nothing
              }
            );
          } else {
            // No schema found, create with empty config
            this.createModule(moduleType, {});
          }
        });
      })
      .catch((error) => {
        console.error("Error loading modules:", error);
        alert("Failed to load available modules. Please refresh the page.");
      });
  }

  createModule(moduleType, configuration) {
    fetch("/cms/marketing_page_modules", {
      method: "POST",
      body: JSON.stringify({
        module_type: moduleType,
        configuration,
      }),
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": document.head.querySelector('meta[name="csrf-token"]')
          .content,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Failed to create module");
      })
      .then((json) => {
        if (json && json.sgid) {
          this.insertAttachment(json);
        }
      })
      .catch((error) => {
        console.error("Error creating module:", error);
        alert("Failed to insert module. Please try again.");
      });
  }

  insertAttachment(moduleData) {
    const attachment = new Trix.Attachment({
      sgid: moduleData.sgid,
      content: moduleData.content,
    });
    this.editor.insertAttachment(attachment);
  }
}

document.addEventListener("trix-initialize", (event) => {
  // Controller sets up event handlers on the Trix editor element
  // eslint-disable-next-line no-new
  new ModuleInserterController(event.target);
});
